// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3CjgC","label":"CategoryService_label__1Ii1A","location":"CategoryService_location__2rocu"};